var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCardTarget = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0V0z",
    id: "ay46uu700a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vawaqh0djb",
    d: "M0 0h70v70H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#ay46uu700a"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "09eaumltoc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vawaqh0djb"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    mask: "url(#09eaumltoc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 -1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.654 8.14 36.13 4.8a27.63 27.63 0 0 0-4.3.322c-8.359 1.284-13.922 6.094-16.05 7.983-9.967 8.843-12.092 21.13-12.226 27.388-.021.985-.083 6.062 1.797 11.013.526 1.384 1.524 3.944 3.826 6.47.429.471.81.838 1.078 1.084l6.905 3.739",
    fill: "#E1BE71"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAE4AE",
    transform: "rotate(-62.44 31.118 35.897)",
    cx: 31.118,
    cy: 35.897,
    rx: 30.473,
    ry: 19.198
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FEF9F2",
    transform: "rotate(-62.44 31.378 36.451)",
    cx: 31.378,
    cy: 36.451,
    rx: 24.693,
    ry: 15.311
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAE4AE",
    transform: "rotate(-64.88 31.772 37.082)",
    cx: 31.772,
    cy: 37.082,
    rx: 18.855,
    ry: 10.658
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FEF9F2",
    transform: "rotate(-64.49 32.204 37.308)",
    cx: 32.204,
    cy: 37.308,
    rx: 12.715,
    ry: 6.641
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAE4AE",
    transform: "rotate(-64.27 32.117 37.12)",
    cx: 32.117,
    cy: 37.12,
    rx: 7.271,
    ry: 3.55
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCardTarget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-card-target.6acae47a1f2252fece6109543f719a20.svg";